import { errorActions } from '@content-platform/web-angular-shared-util-error-handling';
export const LOAD_BY_ID = '[UserRoleList] LOAD BY ID';
export const LOAD_BY_ID_SUCCESS = '[UserRoleList] LOAD SUCCESS BY ID';
export const LOAD_FAILED = '[UserRoleList] LOAD FAILED';
export const LOAD_DEFAULT_ROLES_FOR_DIRECT_ACCESS = '[UserRoleList] LOAD DEFAULT ROLES FOR DIRECT ACCESS';
export const UPDATE = '[UserRoleList] UPDATE';
export const UPDATE_SUCCESS = '[UserRoleList] UPDATE SUCCESS';
export const UPDATE_FAILED = '[UserRoleList] UPDATE FAILED';
export const DELETE_FAILED = '[UserRoleList] DELETE FAILED';
export const CREATE_FAILED = '[UserRoleList] CREATE FAILED';
export class LoadById {
    constructor(payload) {
        this.payload = payload;
        this.type = LOAD_BY_ID;
    }
}
export class LoadByIdSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = LOAD_BY_ID_SUCCESS;
    }
}
export class LoadFailed extends errorActions.Fail {
    constructor() {
        super(...arguments);
        this.type = LOAD_FAILED;
    }
}
export class Update {
    constructor(payload) {
        this.payload = payload;
        this.type = UPDATE;
    }
}
export class UpdateSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = UPDATE_SUCCESS;
    }
}
export class CreateFailed extends errorActions.Fail {
    constructor() {
        super(...arguments);
        this.type = CREATE_FAILED;
    }
}
export class UpdateFailed extends errorActions.Fail {
    constructor() {
        super(...arguments);
        this.type = UPDATE_FAILED;
    }
}
export class DeleteFailed extends errorActions.Fail {
    constructor() {
        super(...arguments);
        this.type = DELETE_FAILED;
    }
}
export class LoadDefaultRolesForDirectAccess {
    constructor() {
        this.type = LOAD_DEFAULT_ROLES_FOR_DIRECT_ACCESS;
    }
}
//# sourceMappingURL=user-role-list.actions.js.map